'use client';
import React from 'react';
import NextImage from 'next/image';
import { useResolvedLocalizedObject } from 'helpers/hooks/useResolvedLocalizedObject';
import useDimensions from './hooks/useDimensions';
import useParameterizedSrc from './hooks/useParameterizedSrc';
import { ImageProps } from './types';
import ReactPlayer from 'react-player';
import cloudinaryLoader from './loaders/cloudinary';
import defaultLoader from './loaders/default';

const Image = ({ media, ratio, gravity, suffix, src, link, width, height, alt = '', title, ...props }: ImageProps) => {
  const parameterizedSrc = useParameterizedSrc({ ratio, gravity, suffix, media, src });
  const dimensions = useDimensions({ media, width, height, ...props });
  const resolvedTitle = useResolvedLocalizedObject(title ?? '');
  const resolvedAlt = useResolvedLocalizedObject(alt ?? '');
  // Type guard to ensure src is a string
  const isYouTubeVideo = typeof src === 'string' && src.includes('youtube.com');
  const isContentfulVideo = typeof src === 'string' && src.includes('videos.ctfassets');
  if (isYouTubeVideo || isContentfulVideo) {
    return (
      <div className="video-container">
        <ReactPlayer className="react-player" url={`${src}`} width="100%" height="100%" controls={true} />
      </div>
      // <iframe
      //   src={`https://www.youtube.com/embed/${videoId}`}
      //   title="Video Player"
      //   width="600"
      //   height="390"
      //   frameBorder="0"
      //   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      //   allowFullScreen
      // ></iframe>
    );
  }
  return (
    <NextImage
      src={parameterizedSrc}
      loader={media?.mediaId ? cloudinaryLoader : defaultLoader}
      alt={resolvedAlt}
      title={resolvedTitle}
      {...dimensions}
      {...props}
    />
  );
};
export default Image;
export * from './types';
